import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
// Gets if Focused Inbox feature is enabled for the user
export function isFocusedInboxEnabled() {
    return (getUserConfiguration().UserOptions.IsFocusedInboxFeatureSupported &&
        getUserConfiguration().UserOptions.IsFocusedInboxEnabled);
}
/**
 * Gets default FocusedViewFilter for selected folder
 * @param folderId of the folder
 */
export default function getDefaultFocusedViewFilterForSelectedFolder(folderId) {
    var distinguishedFolder = folderIdToName(folderId);
    if (distinguishedFolder !== 'inbox') {
        // None if folder is not Inbox
        return -1 /* None */;
    }
    if (!isFocusedInboxEnabled()) {
        // None if Focused Inbox feature is not enabled for user
        return -1 /* None */;
    }
    // Otherwise if Focused Inbox feature is enabled and user is in Inbox
    if (isAllDefaultForFocusedInbox()) {
        // None if IsAllDefaultForFocusedInbox is false or undefined
        return -1 /* None */;
    }
    else {
        // Focused if IsAllDefaultForFocusedInbox true
        return 0 /* Focused */;
    }
}
export function isAllDefaultForFocusedInbox() {
    // Override Focused with All Inbox data when IsAllDefaultForFocusedInbox is true
    // If user is on an old server build, IsAllDefaultForFocusedInbox is undefined, the setting is false
    return !!getUserConfiguration().UserOptions.IsAllDefaultForFocusedInbox;
}
export function isFocusedInboxPivotExperimentOn() {
    return (isMailFeatureEnabled('tri-focused-pivot') ||
        isMailFeatureEnabled('tri-inbox-focused-other-pivot') ||
        isMailFeatureEnabled('tri-inbox-focused-pivot'));
}
//# sourceMappingURL=FocusedInboxUtil.js.map